__turbopack_context__.v({
  "button": "forgot-form-module-scss-module__E-Jr8W__button",
  "status": "forgot-form-module-scss-module__E-Jr8W__status",
});
